// extracted by mini-css-extract-plugin
export default {"App":"App_App__2+VHF","dottedspaced":"App_dottedspaced__kB03f"};